import React from 'react';

function About() {
  return (
    <section className="tc-about-style7">
      <div className="container">
        <div className="row gx-0 justify-content-between">
          <div className="col-lg-3">
            <div className="rotate-box" data-speed="1" data-lag="0.4">
              <a
                href="#"
                className="rotate-circle fsz-30 rotate-text d-inline-block text-uppercase"
              >
                <svg className="textcircle" viewBox="0 0 500 500">
                  <defs>
                    <path
                      id="textcircle"
                      d="M250,400 a150,150 0 0,1 0,-300a150,150 0 0,1 0,300Z"
                    ></path>
                  </defs>
                  <text>
                    <textPath xlinkHref="#textcircle" textLength="900">
                      Landscape design - archin Studio -
                    </textPath>
                  </text>
                </svg>
              </a>
              <img
                src="/innerpages/assets/img/leafs.png"
                alt=""
                className="icon"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
              <h6 className="fsz-45 mb-30 text-capitalize"> Architecture & project management consultancy </h6>
              <div className="text fsz-25 fw-500 mb-20">
                Is a multidisciplinary architecture
                  firm specializing in architecture, master planning, interiors,
                  landscape, and project management consultancy (PMC).
                  With over 35 years of collective expertise, we embrace a
                  collaborative approach to deliver innovative, functional, and
                  sustainable designs across diverse sectors.
              </div>
              <div className="text fsz-25 fw-500 mb-20">
                Our work is driven
                  by a passion for enhancing the built environment while meeting
                  the unique needs and aspirations of our clients.
              </div>
            </div>
          </div>
          <div className="col-lg-2">
            <div className="numbers mt-5 mt-lg-0">
              <div
                className="number-card wow zoomIn slow"
                data-wow-delay="0.4s"
              >
                <h2 className="numb"> 130+ </h2>
                <small> Clients Satisfied and repeating </small>
              </div>
              <div
                className="number-card wow zoomIn slow"
                data-wow-delay="0.6s"
              >
                <h2 className="numb"> 335 </h2>
                <small> projects done </small>
              </div>
              <div
                className="number-card wow zoomIn slow"
                data-wow-delay="0.6s"
              >
                <h2 className="numb"> 25+ </h2>
                <small> Years In Service </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
